import React, { useEffect, useRef, useState } from "react";
import {
  Paper,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  Avatar,
  TableBody,
} from "@mui/material/";
import { Link, useParams } from "react-router-dom";
import { EVENTS_SERVICES } from "../../../../services";
import { ToastManager } from "../../../common/ToastContainer";
import FullPageProgress from "../../../common/FullPageProgress";
import { SESSION_AUTH } from "../../../../helpers/auth";
import moment from "moment";
import {
  SUBSCRIPTION_STATUS_LIST,
  SUBSCRIPTION_MANAGE,
} from "../../../../helpers/constants";

const EventOrgazinationProfile = () => {
  const [loader, setLoader] = useState(false);
  const { userSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const [userData, setUserData] = useState("");
  const [profileData, setProfileData] = useState("");
  const dataFetched = useRef();
  const { accountId } = useParams();

  useEffect(() => {
    if (userSession) {
      setUserData(userSession);
    } else {
      setUserData("");
    }
    return () => null;
  }, [userSession]);

  useEffect(() => {
    if (!userData || !accountId || dataFetched?.current) return;
    dataFetched.current = true;
    setLoader(true);
    let parma = {};
    parma["userId"] = userData.userId;
    parma["id"] = accountId;

    EVENTS_SERVICES.getOrgProfile(parma)
      .then((data) => {
        if (data.code === 200) {
          setProfileData(data?.data);
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
          ToastManager.addToast(data?.message);
        } else {
          ToastManager.addToast(data?.message);
        }
      })
      .catch((error) => {
        ToastManager.addToast(error.message);
      })
      .finally(() => {
        setLoader(false);
      });
  }, [accountId, userData, dataFetched, LOGOUT_USER_SESSION]);

  const SUBSCRIPTIONSTATUS = (status) => {
    switch (status) {
      case 1:
        return SUBSCRIPTION_STATUS_LIST?.[1]?.name;
      case 2:
        return SUBSCRIPTION_STATUS_LIST?.[2]?.name;
      case 3:
        return SUBSCRIPTION_STATUS_LIST?.[3]?.name;
      case 4:
        return SUBSCRIPTION_STATUS_LIST?.[4]?.name;
      case 5:
        return SUBSCRIPTION_STATUS_LIST?.[5]?.name;
      case 6:
        return SUBSCRIPTION_STATUS_LIST?.[6]?.name;
      default:
        return "-";
    }
  };
  return (
    <>
      {loader && <FullPageProgress />}
      {profileData ? (
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell sx={{ width: 300 }}>Logo</TableCell>
                <TableCell>
                  {profileData?.orgLogo ? (
                    <Avatar
                      style={{ width: "40px" }}
                      src={profileData?.orgLogo}
                      alt=""
                    />
                  ) : null}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>{profileData?.orgName}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Public Profile</TableCell>
                <TableCell>
                  <Link
                    to={`${process.env.REACT_APP_EVENT_PLATFORM}/company/${profileData?.orgSlug}`}
                    target="_blank"
                    className="text-link"
                  >
                    View
                  </Link>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Created Date </TableCell>
                <TableCell>
                  {moment(profileData?.createdAt).format(
                    "MMM DD, YYYY : hh:mm A"
                  )}
                </TableCell>
              </TableRow>
              {profileData?.subscription ? (
                <>
                  <TableRow>
                    <TableCell>Subscription status </TableCell>
                    <TableCell>
                      {SUBSCRIPTIONSTATUS(
                        profileData?.subscription?.status
                          ? profileData?.subscription?.status
                          : profileData?.subscription?.statusLabel
                          ? profileData?.subscription?.statusLabel
                          : 0
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Subscription Manage </TableCell>
                    <TableCell>
                      {
                        SUBSCRIPTION_MANAGE?.[profileData?.subscription?.manage]
                          ?.name
                      }{" "}
                      - {profileData?.subscription?.type}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Subscription Start </TableCell>
                    <TableCell>
                      {profileData?.subscription?.startDate
                        ? moment(profileData?.subscription?.startDate).format(
                            "MMM DD, YYYY : hh:mm A"
                          )
                        : ""}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Subscription End </TableCell>
                    <TableCell>
                      {profileData?.subscription?.endDate
                        ? moment(profileData?.subscription?.endDate).format(
                            "MMM DD, YYYY : hh:mm A"
                          )
                        : ""}
                    </TableCell>
                  </TableRow>
                  {profileData?.broadcast?.broName ? (
                    <TableRow>
                      <TableCell>Last Broadcast </TableCell>
                      <TableCell>
                        <strong> {profileData?.broadcast?.broName} </strong>

                        {profileData?.broadcast?.whenTime
                          ? moment(profileData?.broadcast?.whenTime).format(
                              "MMM DD, YYYY : hh:mm A"
                            )
                          : ""}
                      </TableCell>
                    </TableRow>
                  ) : null}
                  {profileData?.lastMeeting ? (
                    <TableRow>
                      <TableCell style={{ verticalAlign: "top" }}>
                        Last Meeting
                      </TableCell>
                      <TableCell>
                        <p>
                          {" "}
                          <Link
                            to={profileData?.lastMeeting?.eventMeetingLink}
                            target="_blank"
                            className="text-link"
                          >
                            {profileData?.lastMeeting?.eventName}
                          </Link>
                        </p>

                        {profileData?.lastMeeting?.sessions &&
                          profileData?.lastMeeting?.sessions.map(
                            (session, index) => (
                              <div key={index} style={{ marginBottom: "20px" }}>
                                <b>
                                  Session {index + 1}:{" "}
                                  {moment(session.created_at).format(
                                    "MMM DD, YYYY : hh:mm A"
                                  )}{" "}
                                  -{" "}
                                  {moment(session.ended_at).format(
                                    "MMM DD, YYYY : hh:mm A"
                                  )}
                                </b>

                                <Table>
                                  <TableBody>
                                    <TableRow>
                                      <TableCell>User</TableCell>
                                      <TableCell>Joined</TableCell>
                                      <TableCell>Left</TableCell>
                                      <TableCell />
                                    </TableRow>
                                    {session.list.map((user, i) => (
                                      <TableRow key={i}>
                                        <TableCell>
                                          {user.name} - {user.user_id}
                                        </TableCell>

                                        <TableCell>
                                          {moment(user.joined_at).format(
                                            "MMM DD, YYYY : hh:mm A"
                                          )}
                                        </TableCell>

                                        <TableCell>
                                          {moment(user.left_at).format(
                                            "MMM DD, YYYY : hh:mm A"
                                          )}
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </div>
                            )
                          )}
                      </TableCell>
                    </TableRow>
                  ) : null}
                </>
              ) : null}
            </TableBody>
          </Table>
        </TableContainer>
      ) : null}
    </>
  );
};

export default EventOrgazinationProfile;
